import { useState, useEffect } from 'react';
import { Table } from 'antd';
import { Link, useNavigate } from "react-router-dom";
import { useLocation, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { fetchEventSettingMarketEventsAsync } from '../../../redux/slice/eventUserGeneralSetting/eventUserGeneralSettingSlice';


function EventSettingEvents() {
    const { event_type_id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isAuthenticated } = useSelector((state) => state.authSlice);
    const profileData = useSelector((state) => state.authSlice.profileData);
    const { eventSettingMarketEvents } = useSelector((state) => state.eventUserGeneralSetting);

    useEffect(() => {
        if (isAuthenticated && profileData?._id) {
            dispatch(fetchEventSettingMarketEventsAsync({
                user_id: profileData?._id,
                event_type_id: event_type_id
            }));
        }
    }, [isAuthenticated, profileData?._id, dispatch, event_type_id])

    const columns = [
        {
            title: 'Name',
            // sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#315195] text-[0.813rem] ml-[5px]'
                    onClick={() => navigate(`/event-general-setting-update/${event_type_id}/${record.event_id}`)}
                >
                    {record.event_name}
                </span>
            ),
        },
        {
            title: 'Date',
            // sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>{new Date(record.open_date).toLocaleString()}</span>
            ),
        }

    ];

    return (
        <div className='relative min-w-full'>
            <div className='grid grid-cols-12 relative mt-[20px] lg:mt-[15px]  px-[15px] lg:px-[30px]' >
                <div className='col-span-12 lg:mx-auto  lg:w-full'>
                    <div className='grid grid-cols-12'>
                        <div className='col-span-12 px-[6px] py-[5px] font-bold text-[0.875rem] rounded-[1px] h-[35px] bg-[linear-gradient(#022c43,_#18b0c8)] text-[#ffffff] flex flex-shrink-0 items-center justify-between'>
                            <h5 className='text-[0.938rem] font-bold mb-0 leading-normal'>Event Listing</h5>
                        </div>
                        <div className='col-span-12 '>

                            <div className='bg-[#fff] border-[1px] border-[#0000002d] '>

                                <div className='p-[0.75rem] flex-auto '>
                                    <Table
                                        columns={columns}
                                        className='downline-list'
                                        bordered
                                        dataSource={eventSettingMarketEvents}
                                        pagination={false}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default EventSettingEvents;
